import { render, staticRenderFns } from "./VueStar.vue?vue&type=template&id=27fff5b6&"
import script from "./VueStar.vue?vue&type=script&lang=js&"
export * from "./VueStar.vue?vue&type=script&lang=js&"
import style0 from "./VueStar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports